import React, { useState, useEffect } from 'react';
import { cn } from '@/lib/utils';
import { Menu, Terminal, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Sheet, SheetContent, SheetTrigger, SheetTitle, SheetClose } from '@/components/ui/sheet';
const NAV_LINKS = [
  { name: 'Services', href: '#services' },
  { name: 'Tech Stack', href: '#tech-stack' },
  { name: 'Scenarios', href: '#scenarios' },
  { name: 'Engagement', href: '#engagement' },
  { name: 'Projects', href: '#projects' },
  { name: 'About', href: '#about' },
  { name: 'Contact', href: '#contact' },
];
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const closeMenu = () => setOpen(false);
  return (
    <header
      className={cn(
        'fixed top-0 left-0 right-0 z-50 transition-all duration-500',
        isScrolled
          ? 'bg-background/95 py-3 border-b border-border shadow-sm'
          : 'bg-transparent py-6 border-b border-transparent'
      )}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between">
        <a href="#" className="flex items-center gap-2 group">
          <div className="w-10 h-10 bg-primary rounded-xl flex items-center justify-center transition-transform group-hover:scale-105 group-active:scale-95 shadow-lg shadow-primary/20">
            <Terminal className="w-6 h-6 text-primary-foreground" />
          </div>
          <span className="text-xl font-bold tracking-tight">
            Hemera<span className="text-blue-500 transition-colors group-hover:text-blue-400">Tech</span>
          </span>
        </a>
        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-10">
          <div className="flex items-center gap-8">
            {NAV_LINKS.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors relative after:absolute after:bottom-[-4px] after:left-0 after:h-[2px] after:w-0 after:bg-primary after:transition-all hover:after:w-full"
              >
                {link.name}
              </a>
            ))}
          </div>
          <div className="h-6 w-px bg-border/60 mx-2" />
          <Button size="sm" className="font-semibold shadow-lg shadow-primary/20" asChild>
            <a href="#contact">Let's Chat</a>
          </Button>
        </nav>
        {/* Mobile Nav */}
        <div className="flex md:hidden items-center gap-3">
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <Button variant="ghost" size="icon" className="hover:bg-accent">
                <Menu className="h-6 w-6" />
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="w-full sm:w-[400px] border-l border-border/50">
              <div className="flex items-center justify-between mb-8">
                <SheetTitle className="text-xl font-bold">Menu</SheetTitle>
              </div>
              <nav className="flex flex-col gap-4">
                {NAV_LINKS.map((link) => (
                  <a
                    key={link.name}
                    href={link.href}
                    onClick={closeMenu}
                    className="text-2xl font-semibold py-4 border-b border-border/40 hover:text-blue-500 transition-all flex items-center justify-between group"
                  >
                    {link.name}
                    <Terminal className="w-5 h-5 opacity-0 group-hover:opacity-100 transition-opacity text-blue-500" />
                  </a>
                ))}
                <div className="pt-8 space-y-4">
                  <Button className="w-full h-14 text-lg font-bold" asChild onClick={closeMenu}>
                    <a href="#contact">Book a Strategy Call</a>
                  </Button>
                  <p className="text-center text-sm text-muted-foreground">
                    Available for new projects in {new Date().getFullYear()}
                  </p>
                </div>
              </nav>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
}